import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { useNavigationBar } from "../../../context/NavigationContext";
import * as Yup from "yup";
import { ContentState, GreetingItem, GreetingTypes, SKGreetingArtifact } from "../../../models/SKArtifact";
import "react-datepicker/dist/react-datepicker.css";
// import { AddTextField } from "./container/components/AddTextField";
import ImageInput from "./ImageInput";
import { FolderName } from "../../../api/shared/uploadService";
import AddImageWithText from "./container/components/AddImageWithText";
import { AddTextField } from "../../../components/AddTextField";

export default function AddGreetings() {
  const { contentData, artifactId, updateContentData, saveData, isEditable } = useContext(CreateArtifactContext);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  const [isValidForm, setIsValidForm] = useState(false);
  const [greetingItems, setGreetingItems] = useState<GreetingItem>();

  const schema = Yup.object().shape({
    greetingType: Yup.string().required(),
    greetingTitle: Yup.string().required(),
    greetingMessage: Yup.string().required(),
  });

  useEffect(() => {
    const validate = async () => {
      try {
        await schema.validate(contentData, { abortEarly: false });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate();
  }, [contentData, schema]);

  useEffect(() => {
    const greetings = GreetingTypes.find(item => item.greetingType === (contentData as SKGreetingArtifact).greetingType);
    if (greetings) {
      setGreetingItems(greetings);
    }
  }, [contentData]);

  useEffect(() => {
    setNavProps(prev => ({
      ...prev,
      backArrow: false,
      buttonTitle: "Done",
      title: "Add Greeting Card",
      getActionItems: undefined,
      enableLink: isEditable ? isValidForm : false,
      onNext: isEditable ? submit : undefined,
      onClose: () => navigate(-1),
      onEdit: undefined,
    }));
  }, [setNavProps, isValidForm, isEditable]);

  const submit = async () => {
    await saveData();
    window.history.back();
  };

  function handleImageChange(index: number, url: string | null): void {
    updateContentData({ greetingImage: url });
  }

  return (
    <>
      <div className="flex flex-col mt-[12px]">
        <span className="content_title mb-[15px]">Greeting Card Preview</span>
        <AddImageWithText
          text={""}
          innerImage={(contentData as SKGreetingArtifact)?.greetingImage ? (contentData as SKGreetingArtifact)?.greetingImage : ""}
        />
      </div>
      <div className="flex flex-col mt-[30px] gap-[30px]">
        <div className="flex flex-col">
          <AddTextField
            name={"addtitle"}
            title={"Add Greeting Title"}
            note={"Main text of your greeting card visible on the card."}
            placeholder={"Greeting"}
            index={1}
            charAllowed={100}
            value={(contentData as SKGreetingArtifact)?.greetingTitle}
            onChange={async e => {
              updateContentData({ greetingTitle: e.target.value! });
            }}
            disabled={!isEditable}
          />
        </div>
        <div className="flex flex-col">
          <AddTextField
            name={"addmessage"}
            title={"Add Message"}
            note={"Message inside the greeting card visible in the detail view."}
            placeholder={"Message"}
            index={2}
            charAllowed={150}
            value={(contentData as SKGreetingArtifact)?.greetingMessage}
            onChange={async e => {
              updateContentData({ greetingMessage: e.target.value! });
            }}
            disabled={!isEditable}
          />
        </div>
        {greetingItems?.IsHaveImage && (
          <div>
            <div className="flex items-center">
              <span>
                <span className="content_count">3</span>
              </span>
              <span className="content_title">Add Greeting Photo</span>
            </div>
            <div className="notes-class-content">
              Photo visible on the greeting card. Recommended aspect ratio of photo is either 4:3, 1:1, or 3:4.
            </div>
            <div>
              <ImageInput
                key={0}
                index={4}
                onFileChange={handleImageChange}
                docId={artifactId!}
                maxFileSize={5}
                imageUrl={(contentData as SKGreetingArtifact)?.greetingImage}
                folder={FolderName.content}
                editable={isEditable}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
